import React from 'react';
import { withPage } from '../../../components/layout/Page/Page';
import { freeCreditsMeta } from '../../misc/MetaTags';
import { Section } from '../../../components/default/Areas/Areas';
import { DEFAULT_FREE_SESSIONS } from '../../../utils/global-variables';

const FreeCredits = () => (
    <Section patterned={true}>
        <h1>Free Test Sessions</h1>
        <h2>What are Free Test Sessions?</h2>
        <p>
            Free test sessions are a way for you to try out our A/B testing platform without any
            financial commitment. You can use these sessions to run tests on your website and
            evaluate the effectiveness of different variations.
        </p>
        <h2>What is a Test Session?</h2>
        <p>
            A test session is counted each time a unique visitor lands on a page that you are A/B
            testing. In simple terms: one person visiting a tested page once = one test session. If
            100 different people visit your test page, that's 100 test sessions. Sessions are what
            we measure and charge for.
        </p>
        <h2>How many Test Sessions do I get?</h2>
        <p>
            Every month, you receive up to {DEFAULT_FREE_SESSIONS} free test sessions - we will top
            up your session balance up to {DEFAULT_FREE_SESSIONS}, meaning if your balance is 300,
            you will get 200 free sessions. If you already have over {DEFAULT_FREE_SESSIONS}{' '}
            sessions, you will not receive any additional free sessions.
        </p>
        <p>
            This gives users a chance to use our software without charge, although your tests will
            be limited. This is the best we can do as each session costs us money to run.
        </p>
        <h2>How do I get Free Test Sessions?</h2>
        <p>
            Free test sessions are automatically added to your account every month. You can use them
            to run tests without any cost. If you need more sessions, you can purchase additional
            ones at any time.
        </p>
        <h2>How do I use Free Test Sessions?</h2>
        <p>
            Using free test sessions is simple. Just log in to your account, create a new test, and
            select the number of sessions you want to allocate to that test. The system will
            automatically deduct the sessions from your free balance with every visitor who visits a
            live test page.
        </p>
        <h2>What happens if I run out of Free Test Sessions?</h2>
        <p>
            If you run out of free test sessions, you can purchase additional sessions at any time
            or wait until the end of the month for new sessions to be automatically added. Your
            tests will pause until you have enough sessions to run them again.
        </p>
    </Section>
);

export default withPage(FreeCredits)({ meta: freeCreditsMeta, fullWidth: true });
